import { useState } from 'react';
import { styled } from '@mui/system';
import { Box, Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LinkToDialog } from './LinkToDialog';
import { DEFAULT_AVATAR } from '../../../../utils/constant';

const DialogLink = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  textTransform: 'none',
  color: 'initial',
  fontWeight: '400',
  padding: '0',
  lineHeight: '27px',
  '&>svg': {
    marginRight: '5px',
  },
});

const InnerYellowFrame = styled(Box)({
  margin: '14px',
  padding: '14px 21px 17px',
  border: '1px solid #AA9178',
  color: '#000000',
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 400,
  minWidth: '320px',
  borderRadius: 0,
});

const DialogTitle = styled('div')({
  fontFamily: 'Fjalla One',
  fontWeight: 600,
  fontSize: '20px',
  textTransform: 'capitalize',
  padding: '0',
  margin: '0 0 23px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const Diamond = styled('div')({
  width: '80px',
  height: '8px',
  textAlign: 'center',
  position: 'relative',
  color: 'rgb(166,146,123)',
  fontSize: '8px',
  lineHeight: '10px',
  marginTop: '10px',
  '&:before,&:after': {
    content: '""',
    width: '32px',
    height: '2px',
    position: 'absolute',
    left: '0',
    border: '1px solid',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '&:before': {},
  '&:after': {
    left: 'auto',
    right: '0',
  },
});

const CloseBtn = styled(IconButton)({
  right: '30px',
  top: '27px',
  position: 'absolute',
  padding: '0',
  zIndex: '1',
});

const UserList = styled('ul')({
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'column',
  padding: '0',
  fontFamily: 'Fjalla One',
  margin: '0',
});

const UserListItem = styled('li')({
  textTransform: 'capitalize',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '&:not(:last-child)': {
    marginBottom: '11px',
  },
});

const UserInfor = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const UserImg = styled('img')({
  borderRadius: '50%',
  width: '100%',
  height: '40px',
  objectFit: 'cover',
});

const UserImgContainer = styled('div')({
  width: '40px',
  height: '40px',
  marginRight: '9px',
  overflow: 'hidden',
});

const UserLink = styled('a')({
  cursor: 'pointer',
  color: '#000000',
  textDecoration: 'none',
});

const LinkToListDialog = ({ title, userList, children }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <DialogLink onClick={() => setOpenModal(true)}>{children}</DialogLink>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{ style: { borderRadius: 0 } }}
      >
        <CloseBtn aria-label="close" onClick={() => setOpenModal(false)}>
          <CloseIcon />
        </CloseBtn>
        <InnerYellowFrame>
          <DialogTitle id="scroll-dialog-title">
            {title}
            <Diamond>♦</Diamond>
          </DialogTitle>
          {/* eslint-disable-next-line */}
          <UserList dividers={scroll === 'paper'}>
            {userList.map((user, id) => {
              return (
                <UserListItem key={id}>
                  <UserInfor>
                    <UserImgContainer>
                      <UserImg
                        src={user.avatar || DEFAULT_AVATAR}
                        alt={user.userName}
                      />
                    </UserImgContainer>
                    <UserLink href={`/user/${user._id}`}>
                      {user.userName}
                    </UserLink>
                  </UserInfor>
                  <LinkToDialog user={user} />
                </UserListItem>
              );
            })}
          </UserList>
        </InnerYellowFrame>
      </Dialog>
    </>
  );
};
export default LinkToListDialog;
